/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CreateWholesaleMenuPage = lazyLoad(
  () => import('./index'),
  module => module.CreateWholesaleMenuPage
);
